import { useMutation } from "@apollo/client/react";
import { DELETE_AML_RULE_REFERENCE_EXCLUSION } from "../../mutations/aml/deleteAmlRuleReferenceExclusion";

export const useDeleteAmlRuleReferenceExclusion = ({
  onCompleted,
  onError,
}: any) => {
  const [deleteAmlRuleReferenceExclusion, { data, loading, error }] =
    useMutation(DELETE_AML_RULE_REFERENCE_EXCLUSION, {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [],
      awaitRefetchQueries: true,
    });

  return { deleteAmlRuleReferenceExclusion, data, loading, error };
};
